import React from "react";
import { Table, Header, TableProps } from "@amzn/awsui-components-console";
import { FixedFeeConfig } from "@amzn/fuse-accounting-central-datastore-client";

interface Props {
  fixedFeeConfig: FixedFeeConfig;
}

const DUMMY_COLUMN_DEFINITION = {
  id: "",
  header: "",
  cell: () => "",
};

export const EstimateBreakdownTable: React.FC<Props> = ({ fixedFeeConfig }) => {
  if (
    !fixedFeeConfig.estimateBreakdown ||
    Object.keys(fixedFeeConfig.estimateBreakdown).length === 0
  ) {
    return null;
  }

  const estimateColumnDefinitions: TableProps.ColumnDefinition<any>[] = [
    DUMMY_COLUMN_DEFINITION,
    {
      id: "month",
      header: "Month",
      cell: (item: any) => (
        <span style={{ fontWeight: item.isTotal ? "bold" : "normal" }}>
          {item.month}
        </span>
      ),
    },
    {
      id: "estimate",
      header: "Estimate Count",
      cell: (item: any) => (
        <span style={{ fontWeight: item.isTotal ? "bold" : "normal" }}>
          {item.estimate.toLocaleString("en-US")}
        </span>
      ),
    },
    DUMMY_COLUMN_DEFINITION,
  ];

  const estimateData = Object.entries(fixedFeeConfig.estimateBreakdown)
    .map(([month, estimate]) => ({
      month: month.substring(0, 7), // Extract yyyy-mm from yyyy-mm-dd
      estimate: estimate as number,
      isTotal: false,
    }))
    .sort((a, b) => a.month.localeCompare(b.month));

  // Calculate total
  const total = estimateData.reduce((sum, item) => sum + item.estimate, 0);

  // Add total row
  const dataWithTotal = [
    ...estimateData,
    {
      month: "Total",
      estimate: total,
      isTotal: true,
    },
  ];

  return (
    <Table
      columnDefinitions={estimateColumnDefinitions}
      items={dataWithTotal}
      wrapLines={false}
      resizableColumns={false}
      header={
        <Header
          counter={`(${Object.entries(fixedFeeConfig.estimateBreakdown).length})`}
        >
          Estimate Breakdown
        </Header>
      }
    />
  );
};
